<template>
  <div v-if="question.isShow" class="question-item">
    <div class="question-title">
      <i v-if="question.tipColor == 1">
        <img src="./image/red.png" alt="">
      </i>
      <i v-else-if="question.tipColor == 2">
        <img src="./image/yellow.png" alt="">
      </i>
      <i v-else-if="question.tipColor == 3">
        <img src="./image/green.png" alt="">
      </i>
      <i v-if="question.isMust">*</i><span>第{{ question.serialNumber }}题：</span>{{ question.title }}
    </div>
    <div v-if="question.note" class="question-note">说明：{{ question.note }}</div>
    <img class="qs-img-preview" :src="question.pictureUrl" alt="">
    <div>
      <div v-for="(item,index) in question.options" :key="index">
        <div v-if="item.optionTitle == '准确时间'" class="option-item">
          <i v-if="!item.selected" @click="selectHandler(item)" class="iconfont iconselect-normal"></i>
          <i v-if="item.selected" @click="selectHandler(item)" class="iconfont iconselect-active"></i>
          <span>准确时间</span>
          <div v-if="item.selected" class="time-item">
            <input @blur="blurHandler" v-model="question.value.firstHour" @input="restrictInput($event,23,'firstHour')" min="0" max="23" type="number" placeholder="时" style="margin-left: 15px">
            <span>:</span>
            <input v-model="question.value.firstMinute" :disabled="question.value.firstHour === ''" @input="restrictInput($event,59,'firstMinute')" min="0" max="59" style="margin-left: 28px" type="number" placeholder="分">
          </div>
        </div>
        <div v-else-if="item.optionTitle == '范围时间'" class="option-item">
          <i v-if="!item.selected" @click="selectHandler(item)"  class="iconfont iconselect-normal"></i>
          <i v-if="item.selected" @click="selectHandler(item)"  class="iconfont iconselect-active"></i>
          <span>范围时间</span>
          <div v-if="item.selected" class="time-item-range">
            <input @blur="blurHandler" v-model="question.value.firstHour" @input="restrictInput($event,23,'firstHour')" min="0" max="23" type="number" placeholder="时" style="margin-left: 15px">
            <span>:</span>
            <input @blur="blurHandler" :disabled="question.value.firstHour === ''" v-model="question.value.firstMinute"  @input="restrictInput($event,59,'firstMinute')" min="0" max="59" style="margin-left: 28px" type="number" placeholder="分">
            ~
            <input @blur="blurHandler" :disabled="question.value.firstHour === ''" v-model="question.value.secondHour" @input="restrictInput($event,23,'secondHour')" min="0" max="23" type="number" placeholder="时" style="margin-left: 15px">
            <span>:</span>
            <input @blur="blurHandler" :disabled="question.value.secondHour === ''" v-model="question.value.secondMinute" @input="restrictInput($event,59,'secondMinute')" min="0" max="59" style="margin-left: 28px" type="number" placeholder="分">
          </div>
        </div>
        <div v-else-if="item.optionTitle == '其他'" class="option-item">
          <i v-if="!item.selected" @click="selectHandler(item)"  class="iconfont iconselect-normal"></i>
          <i v-if="item.selected" @click="selectHandler(item)"  class="iconfont iconselect-active"></i>
          <span>其他</span>
          <input v-model="question.value.other" v-if="item.selected" placeholder="请输入" style="font-size:14px;padding: 5px 10px;margin-left: 25px;border: 1px solid #ccc;border-radius: 5px">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '@/assets/style/editor/quill.core.css'

export default {
  name: 'question-timeRule',//
  props: {
    question: { required: true },
  },
  data () {
    return {
      value: {
        title: "准确时间",
        firstHour: "",
        firstMinute: "",
        secondHour: "",
        secondMinute: "",
        other: "",
      },
      currentIndex: null,
      fileList: [],
      uploader: [],
      imageList: [],
      jumpPageNumber: null,
      show: false
    }
  },//
  created (){
    this.getPicture()
    this.getAnswer()
  },//
  watch: {
  },
  methods: {
    selectHandler(qs) {
      if(qs.selected) {
        qs.selected = false
        this.question.value = {
          title: "",
          firstHour: "",
          firstMinute: "",
          secondHour: "",
          secondMinute: "",
          other: "",
          optionId: "",
        }
      }else {
        this.question.options.forEach((item,index) => {
          item.selected = false
        })
        qs.selected = true
        this.question.value.title = qs.optionTitle
        this.question.value.optionId = qs.id
      }


    },
    getAnswer() {
      if(this.question.hasOwnProperty('answerInfo') && this.question.answerInfo!= '') {
        this.$delete(this.question,'value')
        this.$set(this.question,'value',JSON.parse(this.question.answerInfo))
        this.question.options.forEach((item,index) => {
          if(item.id === this.question.value.optionId) {
            item.selected = true
          }
        })
      }else {
        this.question.value = {
          title: "",
          firstHour: "",
          firstMinute: "",
          secondHour: "",
          secondMinute: "",
          other: "",
          optionId: "",
        }
      }

    },
    restrictInput(event,maxVal,key) {
      console.log(key,maxVal);
      console.log(event.target.value);
      if(event.target.value <0) {
        console.log(1111);
        event.target.value = 0
        this.question.value[key] = 0
      }else if(event.target.value > maxVal) {
        event.target.value = maxVal
        this.question.value[key] = maxVal
      }
    },
    checkIsFill (){
      return true
    },//
    saveAnswer (){
    },
    getPicture(){
      if(this.question.pictureUrl) {
        this.$store.dispatch('getPicture', {url:[this.question.pictureUrl]})
            .then(res => {
              this.question.pictureUrl = res[0]
            })
      }
    },//
    blurHandler() {
      console.log(111);
      console.log(this.value);
      let {firstHour, firstMinute, secondHour, secondMinute} = this.question.value
      if(firstHour === "") {
        this.question.value.firstMinute = this.question.value.secondHour = this.question.value.secondMinute = ""
      }
      if(secondHour === "") {
        this.question.value.secondMinute = ""
      }
      if(firstHour && firstMinute && secondHour && secondMinute) {
        console.log(1111);
        if((firstHour*60*1+firstMinute*1) >= (secondHour*60*1+secondMinute*1)) {
          this.question.value.secondHour = this.question.value.secondMinute = ""
          this.$message.error('前后时间有误')
        }
      }
    },
  }
} //
</script>
<style lang="scss" scoped>
@import "questionCommon";
.option-item {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  i {
    margin-right: 10px;
    text-align: center;
  }
}
.time-item {
  width: 150px;
}
.time-item,.time-item-range {
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-left: 10px;
  padding: 5px 10px;
  input {
    border: none;
    width: 40px;
  }
}
.question-option {
  .option-title {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    span {
      font-size: 16px;
      margin-left: 10px;
    }
  }
  .option-other {

  }
}
</style>